module.exports = "/_next/static/images/techvibes-fa22a5a0f7c72d0cc8d534a3dbe8bc95.png";